<template>
  <div class="Index">
    <div class="window_bg"></div>
    <div class="haerd">
      <div class="haerd_left">
        <div class="backBtn" @click.stop.prevent="goBack">返 回</div>
        <div class="title">让我们认识一下常见的软件</div>
      </div>
    </div>

    <div class="module_box">
      <div class="module">
        <div class="module_text">社交娱乐</div>
        <div class="module_img">
          <div class="img_box">
            <div class="img app_wx"></div>
            <div class="img_text">微信</div>
          </div>
          <div class="img_box">
            <div class="img app_xhs"></div>
            <div class="img_text">小红书</div>
          </div>
          <div class="img_box">
            <div class="img app_dy"></div>
            <div class="img_text">抖音</div>
          </div>
          <div class="img_box">
            <div class="img app_qmkg"></div>
            <div class="img_text">全民K歌</div>
          </div>
        </div>
      </div>
      <div class="module">
        <div class="module_text">购物平台</div>
        <div class="module_img">
          <div class="img_box">
            <div class="img app_pdd"></div>
            <div class="img_text">拼多多</div>
          </div>
          <div class="img_box">
            <div class="img app_tb"></div>
            <div class="img_text">淘宝</div>
          </div>
          <div class="img_box">
            <div class="img app_dy"></div>
            <div class="img_text">抖音</div>
          </div>
          <div class="img_box">
            <div class="img app_jd"></div>
            <div class="img_text">京东</div>
          </div>
        </div>
      </div>
      <div class="module">
        <div class="module_text">外卖团购</div>
        <div class="module_img">
          <div class="img_box">
            <div class="img app_mt"></div>
            <div class="img_text">美团</div>
          </div>
          <div class="img_box">
            <div class="img app_elm"></div>
            <div class="img_text">淘宝闪购</div>
          </div>
          <div class="img_box">
            <div class="img app_dy"></div>
            <div class="img_text">抖音</div>
          </div>
          <div class="img_box">
            <div class="img app_jd"></div>
            <div class="img_text">京东</div>
          </div>
        </div>
      </div>
      <div class="module">
        <div class="module_text"><span>AI</span>智能</div>
        <div class="module_img j_c_s p_l_45">
          <div class="img_box m_r_25">
            <div class="img app_db"></div>
            <div class="img_text">豆包</div>
          </div>
          <div class="img_box m_r_10">
            <div class="img app_deepSeek"></div>
            <div class="img_text">DeepSeek</div>
          </div>
          <div class="img_box m_r_35">
            <div class="img app_xfxh"></div>
            <div class="img_text">讯飞星火</div>
          </div>
          <div class="img_box">
            <div class="img app_jm"></div>
            <div class="img_text">即梦</div>
          </div>
        </div>
      </div>
      <div class="module">
        <div class="module_text">旅游出行</div>
        <div class="module_img">
          <div class="img_box">
            <div class="img app_xc"></div>
            <div class="img_text">携程</div>
          </div>
          <div class="img_box">
            <div class="img app_mt"></div>
            <div class="img_text">美团</div>
          </div>
          <div class="img_box">
            <div class="img app_dy"></div>
            <div class="img_text">抖音</div>
          </div>
          <div class="img_box">
            <div class="img app_12306"></div>
            <div class="img_text">12306</div>
          </div>
        </div>
      </div>
      <div class="module">
        <div class="module_text">社会服务</div>
        <div class="module_img j_c_s p_l_45">
          <div class="img_box m_r_40">
            <div class="img app_wx"></div>
            <div class="img_text">微信</div>
          </div>
          <div class="img_box m_r_40">
            <div class="img app_zfb"></div>
            <div class="img_text">支付宝</div>
          </div>
          <div class="img_box m_r_10">
            <div class="img app_wst"></div>
            <div class="img_text">皖事通</div>
          </div>
          <div class="img_box">
            <div class="img app_fz"></div>
            <div class="img_text">国家反诈中心</div>
          </div>
        </div>
      </div>
      <div class="module">
        <div class="module_text">修图剪辑</div>
        <div class="module_img j_c_s p_l_45">
          <div class="img_box m_r_40">
            <div class="img app_jy"></div>
            <div class="img_text">剪映</div>
          </div>
          <div class="img_box m_r_35">
            <div class="img app_xt"></div>
            <div class="img_text">醒图</div>
          </div>
          <div class="img_box m_r_30">
            <div class="img app_hy"></div>
            <div class="img_text">黄油相机</div>
          </div>
          <div class="img_box">
            <div class="img app_qy"></div>
            <div class="img_text">轻颜相机</div>
          </div>
        </div>
      </div>
      <div class="module">
        <div class="module_text">网络节目</div>
        <div class="module_img">
          <div class="img_box">
            <div class="img app_txsp"></div>
            <div class="img_text">腾讯视频</div>
          </div>
          <div class="img_box">
            <div class="img app_aqy"></div>
            <div class="img_text">爱奇艺</div>
          </div>
          <div class="img_box">
            <div class="img app_mgsp"></div>
            <div class="img_text">芒果TV</div>
          </div>
          <div class="img_box">
            <div class="img app_xmly"></div>
            <div class="img_text">喜马拉雅</div>
          </div>
        </div>
      </div>
      <div class="module">
        <div class="module_text">导航规划</div>
        <div class="module_img j_c_s p_l_45">
          <div class="img_box m_r_20">
            <div class="img app_gddt"></div>
            <div class="img_text">高德地图</div>
          </div>
          <div class="img_box m_r_25">
            <div class="img app_bddt"></div>
            <div class="img_text">百度地图</div>
          </div>
          <div class="img_box">
            <div class="img app_txdt"></div>
            <div class="img_text">腾讯地图</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'moduleIndex',
  components: {},
  data () {
    return {}
  },
  created () {},

  mounted () {},
  beforeDestroy () {},

  methods: {
    async goBack () {
      this.$router.replace({
        path: '/recognize/recognizeIndex'
      })
    }
  }
}
</script>

<style scoped lang="less">
.Index {
  position: relative;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    180deg,
    rgb(95, 141, 255) 6.107%,
    rgb(144, 181, 252) 39.695%,
    rgb(217, 240, 255) 99.237%
  );
  border-radius: 0px;
  .window_bg {
    pointer-events: none; /* 使点击穿透该元素 */
    position: absolute;
    top: -50px;
    left: -50px;
    width: 630px;
    height: 684px;
    background: url(@/assets/use/useIndex/window_bg.png) no-repeat center;
    background-size: 100% 100%;
  }
}
.haerd {
  padding: 40px 30px;
  //   display: flex;
  //   align-items: flex-end;
  //   justify-content: space-between;
  .haerd_left {
    position: relative;
    z-index: 1;
    .backBtn {
      cursor: pointer;
      width: 251px;
      height: 90px;
      background: url(@/assets/use/useIndex/backBtn.png) no-repeat center;
      background-size: 100% 100%;
      font-family: Microsoft YaHei;
      font-weight: bold;
      font-size: 40px;
      color: #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
      text-shadow: 0px 1px 5px rgba(200, 121, 0, 0.5);
      border-radius: 96.5px;
      box-shadow: 0px 6px 12px 1px rgba(182, 118, 118, 0.27);
    }
    .title {
      text-align: center;
      margin-top: 41px;
      // margin-left: 20px;
      font-family: SourceHanSansSC-Regular-2;
      font-weight: bold;
      font-size: 45px;
      //   width: 420px;
      color: #ffffff;
      // line-height: 82px;
    }
  }
}
.module_box {
  width: 100%;
  max-height: 73vh;
  overflow-y: auto;

  .module {
    width: 92%;
      height: 200px;
    display: flex;
    margin: 0 auto;
    margin-bottom: 20px;
    .module_text {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      padding: 15px;
      font-size: 35px;
      font-weight: 500;
      font-family: "SourceHanSansSC-Regular-2";
      width: 8%;
      border-radius: 23px 0px 0px 23px;
      background: rgb(255, 255, 255);
      text-align: center;
      color: rgb(0, 111, 255);
      letter-spacing: 1px;
      line-height: 40px;
    }
    .module_img {
      width: 92%;
      border-radius: 0px 23px 23px 0px;
      background: rgb(220, 233, 255);
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      //   padding: 30px 40px;
      .img_box {
        // margin-right: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        .img {
          width: 100px;
          height: 100px;
        }
        .img_text {
          color: rgb(51, 51, 51);
          font-family: "SourceHanSansSC-Regular-2";
          font-size: 28px;
          font-weight: 700;
          line-height: 40px;
          letter-spacing: 1px;
          text-align: center;
          margin-top: 5px;
        }
      }
      //   .img_box:last-child {
      //     margin-right: 0;
      //   }
    }
    .j_c_s {
        justify-content: flex-start;
    }
    .p_l_45{
   padding-left: 45px;
    }
    .m_r_10 {
    margin-right: 10px;
    }
    .m_r_15 {
    margin-right: 15px;
    }
    .m_r_20 {
    margin-right: 20px;
    }
    .m_r_25 {
    margin-right: 25px;
    }
    .m_r_30 {
    margin-right: 30px;
    }
    .m_r_35 {
    margin-right: 35px;
    }
    .m_r_40 {
    margin-right: 40px;
    }
    .app_wx {
      background: url("@/assets/recognize/software/app_wx.png") no-repeat center;
      background-size: 100% 100%;
    }
    .app_xhs {
      background: url("@/assets/recognize/software/app_xhs.png") no-repeat
        center;
      background-size: 100% 100%;
    }
    .app_dy {
      background: url("@/assets/recognize/software/app_dy.png") no-repeat center;
      background-size: 100% 100%;
    }
    .app_qmkg {
      background: url("@/assets/recognize/software/app_qmkg.png") no-repeat
        center;
      background-size: 100% 100%;
    }
    .app_pdd {
      background: url("@/assets/recognize/software/app_pdd.png") no-repeat
        center;
      background-size: 100% 100%;
    }
    .app_tb {
      background: url("@/assets/recognize/software/app_tb.png") no-repeat center;
      background-size: 100% 100%;
    }
    .app_jd {
      background: url("@/assets/recognize/software/app_jd.png") no-repeat center;
      background-size: 100% 100%;
    }
    .app_mt {
      background: url("@/assets/recognize/software/app_mt.png") no-repeat center;
      background-size: 100% 100%;
    }
    .app_elm {
      background: url("@/assets/recognize/software/app_elm.png") no-repeat
        center;
      background-size: 100% 100%;
    }
    .app_db {
      background: url("@/assets/recognize/software/app_db.png") no-repeat center;
      background-size: 100% 100%;
    }
    .app_deepSeek {
      background: url("@/assets/recognize/software/app_deepSeek.png") no-repeat
        center;
      background-size: 100% 100%;
    }
    .app_xfxh {
      background: url("@/assets/recognize/software/app_xfxh.png") no-repeat
        center;
      background-size: 100% 100%;
    }
    .app_jm {
      background: url("@/assets/recognize/software/app_jm.png") no-repeat center;
      background-size: 100% 100%;
    }
    .app_xc {
      background: url("@/assets/recognize/software/app_xc.png") no-repeat center;
      background-size: 100% 100%;
    }
    .app_12306 {
      background: url("@/assets/recognize/software/app_12306.png") no-repeat
        center;
      background-size: 100% 100%;
    }
    .app_zfb {
      background: url("@/assets/recognize/software/app_zfb.png") no-repeat
        center;
      background-size: 100% 100%;
    }
    .app_wst {
      background: url("@/assets/recognize/software/app_wst.png") no-repeat
        center;
      background-size: 100% 100%;
    }
    .app_fz {
      background: url("@/assets/recognize/software/app_fz.png") no-repeat center;
      background-size: 100% 100%;
    }
    .app_jy {
      background: url("@/assets/recognize/software/app_jy.png") no-repeat center;
      background-size: 100% 100%;
    }
    .app_xt {
      background: url("@/assets/recognize/software/app_xt.png") no-repeat center;
      background-size: 100% 100%;
    }
    .app_hy {
      background: url("@/assets/recognize/software/app_hy.png") no-repeat center;
      background-size: 100% 100%;
    }
    .app_qy {
      background: url("@/assets/recognize/software/app_qy.png") no-repeat center;
      background-size: 100% 100%;
    }
    .app_txsp {
      background: url("@/assets/recognize/software/app_txsp.png") no-repeat
        center;
      background-size: 100% 100%;
    }
    .app_aqy {
      background: url("@/assets/recognize/software/app_aqy.png") no-repeat
        center;
      background-size: 100% 100%;
    }
    .app_mgsp {
      background: url("@/assets/recognize/software/app_mgsp.png") no-repeat
        center;
      background-size: 100% 100%;
    }
    .app_xmly {
      background: url("@/assets/recognize/software/app_xmly.png") no-repeat
        center;
      background-size: 100% 100%;
    }
    .app_gddt {
      background: url("@/assets/recognize/software/app_gddt.png") no-repeat
        center;
      background-size: 100% 100%;
    }
    .app_bddt {
      background: url("@/assets/recognize/software/app_bddt.png") no-repeat
        center;
      background-size: 100% 100%;
    }
    .app_txdt {
      background: url("@/assets/recognize/software/app_txdt.png") no-repeat center;
      background-size: 100% 100%;
    }
  }
}
</style>
